import React from 'react';
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import markerIcon from '../../../images/marker.png';
import { Evento } from '../../../utils/entities/Evento';

const MiniMap = withGoogleMap((props: any) => {
  const evento: Evento = props.evento;

  return (
    <GoogleMap
      center={{
        lat: evento ? evento.coords.x : -34.8833,
        lng: evento ? evento.coords.y : -56.1667,
      }}
      defaultOptions={{
        draggable: false,
        gestureHandling: 'greedy',
        disableDefaultUI: true,
        zoom: 15,
        minZoom: 15,
        maxZoom: 15,
        streetViewControl: false,
        rotateControl: false,
        panControl: false,
        mapTypeControl: false,
        keyboardShortcuts: false,
      }}
    >
      <Marker
        icon={markerIcon}
        position={{
          lat: evento ? evento.coords.x : -34.8833,
          lng: evento ? evento.coords.y : -56.1667,
        }}
      />
    </GoogleMap>
  );
});

export default MiniMap;
